import { useEffect, useState } from 'react';

/** Returns `value` after it has stayed unchanged for `ms`. The first render returns the value immediately. */
export function useDebouncedValue<T>(value: T, ms: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), ms);
    return () => clearTimeout(timer);
  }, [value, ms]);
  return debounced;
}
